import React, { PureComponent } from 'react';
import { Popover } from 'antd';
import TableC from '../../../basicElement/TableC';

export default class Total extends PureComponent {
    getColumns = () => {
        const { searchParams, performanceState } = this.props;
        const { date } = searchParams;
        const { params: { areaName, positionName } } = performanceState;
        return [{
            title: '排名',
            dataIndex: 'rank',
            key: 'rank',
            width: 80,
            render: text => {
                return (
                    <div>
                        <Popover
                            placement="top"
                            overlayClassName="contract-pop"
                            content={<div>
                                {<strong>排名统计条件:<br/></strong>}
                                {<span>时间: {date} <br/></span>}
                                {<span>区域/城市: {areaName} <br/></span>}
                                {<span>职位级别: {positionName} <br/></span>}
                            </div>}
                            trigger="hover"
                        >
                            <i className='pop' style={{cursor: 'pointer'}}></i>
                        </Popover>
                        <div className='pop-div'>{text}</div>
                    </div>
                )
            }
        }, {
            title: '带教老师姓名',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            width: 100,
        }, {
            title: '带教老师工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            width: 100,
        }, {
            title: '职位/级别',
            dataIndex: 'positionName',
            key: 'positionName',
            width: 100,
        }, {
            title: '区域',
            dataIndex: 'areaName',
            key: 'areaName',
            width: 60,
        }, {
            title: '城市',
            dataIndex: 'workCityName',
            key: 'workCityName',
            width: 60,
        },  {
            title: '主管姓名',
            dataIndex: 'leaderUserCompellation',
            key: 'leaderUserCompellation',
            width: 100,
        },  {
            title: '主管工号',
            dataIndex: 'leaderEmployeeCode',
            key: 'leaderEmployeeCode',
            width: 100,
        }, {
            title: '总分',
            dataIndex: 'totalPoint',
            key: 'totalPoint',
            width: 60,
        }, {
            title: '主要业绩分',
            dataIndex: 'mainAchievementPoint',
            key: 'mainAchievementPoint',
            width: 60,
        }, {
            title: '减分',
            dataIndex: 'minusPoint',
            key: 'minusPoint',
            width: 60,
        }];
    }

    render() {
        const { data } = this.props;
        return (
            <TableC
                data={data}
                columns={this.getColumns()}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/home/TeachingDetail/tables/Total.js